export default __webpack_public_path__ + "static/media/Password.2aebb208.svg";